var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 23,
    viewBox: "0 0 51 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00024 9.60852C1.17182 9.60852 0.500244 10.2801 0.500244 11.1085C0.500244 11.9369 1.17182 12.6085 2.00024 12.6085V9.60852ZM50.0609 12.1692C50.6467 11.5834 50.6467 10.6336 50.0609 10.0479L40.515 0.501919C39.9292 -0.0838676 38.9794 -0.0838676 38.3936 0.501919C37.8079 1.08771 37.8079 2.03745 38.3936 2.62324L46.8789 11.1085L38.3936 19.5938C37.8079 20.1796 37.8079 21.1293 38.3936 21.7151C38.9794 22.3009 39.9292 22.3009 40.515 21.7151L50.0609 12.1692ZM2.00024 12.6085H49.0002V9.60852H2.00024V12.6085Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_right.15a6e9de.svg";
export { ForwardRef as ReactComponent };